import Vue from 'vue'
import { FORM_OPTIONS } from '@/CONSTS'
/**
 * directive: 数値を整数にし、３桁区切りの価格表記に修正する
 * <span v-price="{{ Number }}"></span>
 */
Vue.directive('order-category', {
  bind(el, bindings) {
    const { value } = bindings
    const genres = FORM_OPTIONS.order_genre
    const genre = genres.find(genre => genre.value === value)
    Object.assign(el, {
      textContent: genre ? genre.text : '設定されていません'
    })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/orderCategory.js